import React from 'react';

const ProfileResearchFieldForm = ({ isOpen, onClose, onSubmit, formData, setFormData, categories = [], isEditing }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box">
                <div className="modal-header">
                    <h3>{isEditing ? "Cập nhật Lĩnh vực nghiên cứu" : "Thêm mới Lĩnh vực nghiên cứu"}</h3>

                    <button
                        type="button"
                        className="close-btn"
                        onClick={onClose}
                        style={{ fontSize: '24px', lineHeight: '1', display: 'flex', alignItems: 'center' }}
                    >
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="researchFieldForm" onSubmit={onSubmit}>
                        <div className="form-group">
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Lĩnh vực nghiên cứu *</label>
                            <select
                                name="ResearchFieldName"
                                className="form-input"
                                value={formData.ResearchFieldName || ''}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Chọn lĩnh vực</option>
                                {categories.map((cat) => (
                                    <option key={cat.Id} value={cat.Name}>{cat.Name}</option>
                                ))}
                            </select>
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="researchFieldForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default ProfileResearchFieldForm;